export default {
	methods: {
		convertToMediaSchema(mediaObject) {
			console.log(mediaObject)
			let mediaArray = Object.entries(mediaObject)
			// console.log(array)
			let mediaSchema = []
			let counter = 0

			for (const [uuid, mediaItem] of mediaArray) {
				let newMediaItem = {
					extension: mediaItem.extension,
					name: mediaItem.name,
					order: counter,
					uuid: mediaItem.uuid,
					size: mediaItem.size,
				}
				if (typeof mediaItem.custom_properties !== 'undefined') {
					newMediaItem.custom_properties = {
						title: mediaItem.custom_properties.title,
						description: mediaItem.custom_properties.description
					}
				}
				mediaSchema.push(newMediaItem)
				counter++
			}
			return mediaSchema
		},
		setMediaOrder(media) {
			let counter = 0;
			media.forEach((mediaItem, index) => {
				media[index].order = counter
				counter++
			})
			return media;
		},
		getImageUrl(resource, name, width = 66, height = 83) {
			if (!resource[name] || !resource[name].length) {
				var placeholder
				if (width > 66) {
					placeholder = 'placeholder-full.png'
				}
				else {
					placeholder = 'resource-placeholder.png'
				}
				return process.env.MIX_APP_URL + '/images/' + placeholder
			}
			if (name == 'city_image_url_thumb' || name == 'image_url_thumb') {
				return resource[name]
			}
			return resource[name][0].full_url
		}
	}
}